import { render, staticRenderFns } from "./robotList.vue?vue&type=template&id=ae5e3134"
import script from "./robotList.vue?vue&type=script&lang=js"
export * from "./robotList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports